import firmware from '@/views/product/views/firmware/firmware'
export default firmware;